import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { InputWithExtra } from './input-with-extra';

export function TrackingTemplate(props) {
  return (
    <React.Fragment>
      <InputWithExtra
        placeholder={props.i18n.getString(_TL_('Enter a Tracking template'))}
        {..._.omit(props, 'inputExtraClass')}
        extra={() => <span className={props.inputExtraClass}>{props.i18n.getString(_TL_('Example: http://www.trackingtool.com/tracking?url={lpurl}&type=1'))}</span>}
      />
    </React.Fragment>
  );
}

TrackingTemplate.propTypes = {
  inputExtraClass: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

TrackingTemplate.defaultProps = {
  inputExtraClass: '',
};
